import { render, staticRenderFns } from "./myInvoices.vue?vue&type=template&id=742c785d&scoped=true&"
import script from "./myInvoices.vue?vue&type=script&lang=js&"
export * from "./myInvoices.vue?vue&type=script&lang=js&"
import style0 from "./myInvoices.vue?vue&type=style&index=0&id=742c785d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c785d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VChip,VDataTable})
